// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DreamAttributeIcon__important___j6Ofe {
    color: yellow;
    text-shadow: 0px 0px 15px orange;
}

.DreamAttributeIcon__important_ifDesktop___n1ghc {
    animation: DreamAttributeIcon__glow___WIVnx 2s alternate infinite;
}

@keyframes DreamAttributeIcon__glow___WIVnx {
    from { text-shadow: 0px 0px 0px orange; }
    to { text-shadow: 0px 0px 15px orange; }
}

.DreamAttributeIcon__flag___SclqT {
    color: gold;
    text-shadow: 0px 0px 15px orange;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"important": `DreamAttributeIcon__important___j6Ofe`,
	"important_ifDesktop": `DreamAttributeIcon__important_ifDesktop___n1ghc`,
	"glow": `DreamAttributeIcon__glow___WIVnx`,
	"flag": `DreamAttributeIcon__flag___SclqT`
};
module.exports = ___CSS_LOADER_EXPORT___;
